// StatusBadge.jsx
// PO status badge component

import React from 'react';

const STATUS_COLORS = {
    draft: { bg: 'var(--color-bg-panel)', text: 'var(--color-text-primary)' },
    submitted: { bg: 'var(--color-info-light)', text: 'var(--color-info-dark)' },
    partial: { bg: 'var(--color-warning-light)', text: 'var(--color-warning-dark)' },
    received: { bg: 'var(--color-success-light)', text: 'var(--color-success-dark)' },
    cancelled: { bg: 'var(--color-danger-light)', text: 'var(--color-danger-dark)' }
};

const STATUS_LABELS = {
    draft: 'Draft',
    submitted: 'Submitted',
    partial: 'Partial',
    received: 'Received',
    cancelled: 'Voided'
};

const StatusBadge = ({ status }) => {
    const colors = STATUS_COLORS[status] || STATUS_COLORS.draft;
    const label = STATUS_LABELS[status] || status;
    return (
        <span style={{
            display: 'inline-block',
            padding: '3px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 500,
            backgroundColor: colors.bg,
            color: colors.text
        }}>
            {label}
        </span>
    );
};

export default StatusBadge;
